var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"main"},[_c('van-button',{attrs:{"text":"立即支付"},on:{"click":_vm.wechatPay}}),_c('van-button',{attrs:{"text":"调起支付"},on:{"click":_vm.jsapiPay}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }